module.exports = __webpack_public_path__ + "media/slider/Subscription-3-7f8a1fbb.jpg";